<template>
    <div class="main">
        <el-form label-position="top">
            <el-tabs type="border-card" v-model="tabAtivo">
                <el-tab-pane label="FILTROS" name="filtros">

                    <!-- Tipo de relatório -->
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24">
                            <el-form-item label="Relatório">
                                <el-select v-model="tipo" @change="changeTipo" placeholder="Selecione o relatório" style="width: 100%;">
                                    <el-option v-for="r in relatorios" :key="r.value" :label="r.label" :value="r.value"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- Instituição / Período letivo -->
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="18">
                            <el-form-item label="Instituição" key="instituicao" v-if="ehSmed">
                                <el-select @change="getTurmas()" v-model="filtro.instituicao_id" filterable clearable placeholder="- TODAS AS INSTITUIÇÕES -" style="width: 100%;">
                                    <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <div class="style-form" v-else>
                                <label>Instituição</label>
                                <div class="style-input readonly">{{ $store.state.config.instituicao ? $store.state.config.instituicao.nome : '' }}</div>
                            </div>
                        </el-col>
                        <el-col :xs="24" :sm="6">
                            <el-form-item label="Período">
                                <el-select @change="getTurmas()" v-model="filtro.periodo_letivo_id" style="width: 100%;">
                                    <el-option v-for="(item, i) in $store.state.periodos" :key="i" :label="'Periodo Letivo ' + item.nome" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- Turma (opcional) -->
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="24">
                            <el-form-item label="Turma (opcional)">
                                <el-select v-model="filtro.turma_id" clearable filterable placeholder="Todas as turmas" style="width: 100%;">
                                    <el-option-group v-for="(grupo, i) in turmas" :key="i" :label="i">
                                        <el-option v-for="turma in grupo" :key="turma.id" :label="`${turma.curso.nome} ${turma.nome}`" :value="turma.id"></el-option>
                                    </el-option-group>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- Origem (apenas para downloads) -->
                    <el-row :gutter="10" v-if="tipo === 'downloads'">
                        <el-col :xs="24" :sm="24">
                            <el-form-item label="Origem do download (opcional)">
                                <el-select v-model="filtro.origem" clearable placeholder="Todos" style="width: 100%;">
                                    <el-option label="Materiais publicados (baixados por alunos)" value="material"></el-option>
                                    <el-option label="Devoluções de aluno (baixadas por prof/coord)" value="retorno"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- Intervalo de datas -->
                    <el-row :gutter="10">
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Data inicial (opcional)">
                                <el-date-picker v-model="filtro.data_inicio" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Início" style="width: 100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :xs="24" :sm="12">
                            <el-form-item label="Data final (opcional)">
                                <el-date-picker v-model="filtro.data_fim" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Fim" style="width: 100%;"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                </el-tab-pane>
            </el-tabs>

            <div class="u-mt-10">
                <el-row>
                    <el-col :xs="24" :sm="24" class="u-text-right">
                        <el-button @click="gerar()" type="primary" :disabled="!tipo">
                            <i class="el-icon-printer"></i> GERAR PDF
                        </el-button>
                    </el-col>
                </el-row>
            </div>
        </el-form>
    </div>
</template>

<script>
export default {
    data: () => ({
        tabAtivo: 'filtros',
        tipo: '',
        relatorios: [
            { value: 'enviados-professor', label: 'Arquivos enviados por professor/coordenador' },
            { value: 'enviados-aluno',     label: 'Arquivos enviados por aluno (devoluções)' },
            { value: 'downloads',          label: 'Downloads realizados' }
        ],
        filtro: {
            instituicao_id: '',
            periodo_letivo_id: '',
            turma_id: '',
            origem: '',
            data_inicio: '',
            data_fim: ''
        },
        turmas: []
    }),
    computed: {
        ehSmed () {
            const t = this.$store.state.user.tipo
            return t == 10 || (t > 3 && t <= 8)
        }
    },
    mounted () {
        this.filtro.periodo_letivo_id = this.$store.state.config.parametros.periodo_letivo_situacao_academica

        if (!this.ehSmed && this.$store.state.config.instituicao) {
            this.filtro.instituicao_id = this.$store.state.config.instituicao.id
        }

        this.getTurmas()
    },
    methods: {
        changeTipo () {
            this.filtro.origem = ''
        },

        getTurmas () {
            this.filtro.turma_id = ''

            if (!this.filtro.instituicao_id || !this.filtro.periodo_letivo_id) {
                this.turmas = []
                return
            }

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getTurmasForListDiario/${this.filtro.instituicao_id}/${this.filtro.periodo_letivo_id}`, this.$store.getters.getHeaderAuth).then(response => {
                this.turmas = response.data
            }).catch(error => { this.$store.commit('throwException', error) })
        },

        gerar () {
            if (this.ehSmed && !this.filtro.instituicao_id && !this.filtro.turma_id) {
                window.eventBus.$emit('alert', { msg: 'Selecione ao menos a instituição ou a turma.', type: 'warning' })
                return
            }

            const param = {
                instituicao_id: this.filtro.instituicao_id || '',
                turma_id: this.filtro.turma_id || '',
                data_inicio: this.filtro.data_inicio || '',
                data_fim: this.filtro.data_fim || ''
            }
            if (this.tipo === 'downloads' && this.filtro.origem) param.origem = this.filtro.origem

            window.eventBus.$emit('print', {
                url: `/api/material-turma/relatorio/${this.tipo}`,
                param: param
            })
        }
    }
}
</script>
